<template>
  <div
    class="modal fade"
    id="shopperProposalModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" data-dismiss="modal" aria-hidden="true">
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.SPM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="col-md-2 control-label">{{ lang.SPM001 }}</label>
            <div class="col-md-4">
              <select2
                class="form-control"
                id="newShopperProposalCarSegmentSelect"
                v-model="selectedCarSegment"
                @change="selectedCarModel = ''"
                :placeholder="lang.SPM002"
                :allowClear="true"
              >
                <option></option>
                <option
                  v-for="segment in carSegmentList"
                  :key="segment.CarSegmentGuid"
                  :value="segment.CarSegmentGuid"
                >
                  {{ segment.CarSegmentName }}
                </option>
              </select2>
            </div>
            <div class="col-md-4">
              <select2
                class="form-control"
                id="newShopperProposalCarModelSelect"
                v-model="selectedCarModel"
                @change="selectedCompetitorCar = ''"
                :placeholder="lang.SPM003"
                :allowClear="true"
                :disabled="!selectedCarSegment"
              >
                <option></option>
                <option
                  v-for="model in carModelsOfSelectedSegment"
                  :key="model.CarModelGuid"
                  :value="model.CarModelGuid"
                >
                  {{ model.CarModelName }}
                </option>
              </select2>
            </div>
          </div>
          <div class="form-group" v-if="check.CompetitorCarModelDistribution">
            <label class="col-md-2 control-label">{{ lang.SPM004 }}</label>
            <div class="col-md-8">
              <select2
                class="form-control"
                id="newShopperProposalCompetitorCarModelSelect"
                v-model="selectedCompetitorCar"
                @change="selectedCarModel = ''"
                :placeholder="lang.SPM005"
                :allowClear="true"
                :disabled="!selectedCarSegment"
              >
                <option></option>
                <option
                  v-for="model in check.CompetitorCarModelDistribution"
                  :key="model.CompetitorCarModelGuid"
                  :value="model.CompetitorCarModelGuid"
                >
                {{ model.CompetitorCarBrand }} {{ model.CompetitorCarModel }}
                </option>
              </select2>
            </div>
          </div>

          <div class="form-group">
            <label
              class="col-md-2 control-label"
              style="display: flex; align-items: center; min-height: 24px"
            >
              <span style="margin-left: 11px">
                {{ lang.SPM006 }}
              </span>
              <i
                class="material-icons md-24"
                style="color: red"
                id="shopperLabel"
                v-if="this.shopperPreviousVisited"
              >
                info_outline
              </i>
            </label>
            <b-tooltip
              ref="tooltip"
              :target="`shopperLabel`"
              v-if="this.shopperPreviousVisited"
            >
              <!-- :delay="globals.tooltipDelay" -->
              <div class="survey-id-info-tooltip">
                {{ lang.SPM034 }}
                <br />
              </div>
            </b-tooltip>

            <div class="col-md-8">
              <select2
                class="form-control"
                id="newShopperProposalShopperSelect"
                v-model="selectedShopper"
                @change="(selectedShopperCar = ''), shopperAlreadyChecked(), getShopperCars()"
                :placeholder="lang.SPM007"
                :allowClear="true"
                :disabled="anyShopperAlreadyApproved"
              >
                <option></option>
                <option
                  v-for="shopper in unproposedShoppers"
                  :key="shopper.ShopperGuid"
                  :value="shopper.ShopperGuid"
                >
                  {{ shopper.ShopperName }}
                </option>
              </select2>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-default btn-fab"
                @click="addShopper()"
                :disabled="
                  !selectedShopperCar ||
                  !selectedCarSegment ||
                  (!selectedCarModel && !selectedCompetitorCar)"
              >
                <i class="material-icons md-36 text-green">add</i>
              </button>
            </div>
          </div>

          <div class="form-group form-group-inline">
            <label class="col-md-2 control-label">{{ lang.SPM008 }}</label>
            <div class="col-md-6">
              <select2
                class="form-control"
                id="newShopperProposalShopperCarSelect"
                v-model="selectedShopperCar"
                :placeholder="lang.SPM009"
                :allowClear="true"
                :disabled="!selectedShopper"
              >
                <option></option>
                <option
                  v-for="car in shopperCars"
                  :key="car.ValueGroupGuid"
                  :value="car.ValueGroupGuid"
                >
                  {{ car.Brand }} {{ car.Model }} ({{ car.Year }})
                </option>
              </select2>
            </div>
          </div>
          <div class="form-group form-group-inline">
            <div class="col-md-2">
              <select
                class="form-control"
                id="newShopperProposalCarMatchSelect"
                v-model="selectedCarMatch"
              >
                <option value="+">+ {{ lang.SPM010 }}</option>
                <option value="=">= {{ lang.SPM011 }}</option>
                <option value="-">- {{ lang.SPM012 }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-12">
            <hr />
          </div>

          <template v-if="check && check.ShopperProposals">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center" style="width: 10%">ID</th>
                  <th class="text-center" style="width: 30%">
                    {{ lang.SPM013 }}
                  </th>
                  <th class="text-center" style="width: 20%">
                    {{ lang.SPM014 }} ({{ lang.SPM015 }})
                  </th>
                  <th class="text-center" style="width: 20%">
                    {{ lang.SPM016 }}
                  </th>
                  <th class="text-center" style="width: 8%">
                    {{ lang.SPM017 }}
                  </th>
                  <th class="text-center" style="width: 12%">
                    {{ lang.SPM018 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="proposal in check.ShopperProposals"
                  :key="proposal.ShopperProposalGuid"
                >
                  <td>{{ proposal.ShopperId }}</td>
                  <td>{{ proposal.DisplayName }}</td>
                  <td>
                    {{ proposal.CarModelName }}
                    <template v-if="proposal.CarSegmentName">({{ proposal.CarSegmentName }})</template>
                  </td>
                  <td>{{ proposal.ShopperCar }}</td>
                  <td>{{ proposal.CarMatch }}</td>
                  <td>
                    <button
                      :id="`openProposalFeedButton-${proposal.ShopperProposalGuid}`"
                      class="btn nopadding"
                      @click="showFeed(proposal)"
                    >
                      <i class="material-icons md-24">forum</i>
                    </button>
                    <b-tooltip
                      ref="tooltip"
                      :target="`openProposalFeedButton-${proposal.ShopperProposalGuid}`"
                      :delay="globals.tooltipDelay"
                    >{{ lang.SPM019 }}</b-tooltip>
                    <template v-if="proposal.UpdateShopperProposal">
                      <button
                        :id="`updateShopperDataButton-${proposal.ShopperProposalGuid}`"
                        class="btn nopadding"
                        @click="updateShopperData(proposal)"
                      >
                        <i class="material-icons md-24">refresh</i>
                      </button>
                      <b-tooltip
                        ref="tooltip"
                        :target="`updateShopperDataButton-${proposal.ShopperProposalGuid}`"
                        :delay="globals.tooltipDelay"
                      >{{ lang.SPM020 }}</b-tooltip>
                    </template>
                    <button
                      :id="`deleteShopperProposalButton-${proposal.ShopperProposalGuid}`"
                      class="btn nopadding"
                      @click="deleteShopper(proposal)"
                      :disabled="proposal.AgencyApprovalStatus"
                    >
                      <i class="material-icons md-24 text-red">clear</i>
                    </button>
                    <b-tooltip
                      ref="tooltip"
                      :target="`deleteShopperProposalButton-${proposal.ShopperProposalGuid}`"
                      :delay="globals.tooltipDelay"
                    >{{ lang.SPM021 }}</b-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
        <div class="table-container">
            <table
              class="table outer-table"
            >
              <thead>
                <tr>
                  <th class="nopadding noborder" style="width: 30%"></th>
                  <th class="nopadding noborder" style="width: 70%"></th>
                </tr>
              </thead>
              <tbody>                  
                <tr v-if="statusData.CarDistribution && check.Brand === 'Audi'">
                  <td class="text-left">
                    <b>{{ lang.AWS029 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>{{ lang.AWS030 }}</th>
                          <th>{{ lang.AWS031 }}</th>
                          <th>{{ lang.AWS032 }}</th>
                          <th>{{ lang.AWS026 }}</th>
                          <th>{{ lang.AWS028 }}</th>
                          <th>{{ lang.AWS027 }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(model, index) in statusData.CarDistribution"
                          :key="index"
                        >
                          <td>{{ model.CarModelName }}</td>
                          <td>
                            {{ Number((model.SetValue * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ActualValue * 100).toFixed(2)) }} % ({{ model.ApprovedCarCount }})
                          </td>
                          <td>
                            {{ Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2)) }} %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <template v-if="statusData.CompetitorCarDistribution && check.Brand !== 'Audi'">
                  <tr v-for="(competitorCarDistribution, index) in getGroupedCompetitorCars()">
                    <td class="text-left">
                      <b>{{ competitorCarDistribution[0] }} {{ lang.AWS033 }}</b>
                    </td>
                    <td class="text-left">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>{{ lang.AWS030 }}</th>
                            <th>{{ lang.AWS031 }}</th>
                            <th>{{ lang.AWS032 }}</th>
                            <th>{{ lang.AWS026 }}</th>
                            <th>{{ lang.AWS028 }}</th>
                            <th>{{ lang.AWS027 }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(model, index) in competitorCarDistribution[1]" :key="index">
                            <td>{{ model.CompetitorCarModel }}</td>
                            <td>
                              {{ Number((model.SetValue * 100).toFixed(2)) }} %
                            </td>
                            <td>
                              {{ Number((model.ActualValue * 100).toFixed(2)) }} % ({{ model.ApprovedCarCount }})
                            </td>
                            <td>
                              {{ Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2)) }} %
                            </td>
                            <td>
                              {{ Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2)) }} %
                            </td>
                            <td>
                              {{ Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2)) }} %
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
        </div>
        <div class="modal-footer">
          <button class="btn btn-raised" data-dismiss="modal">
            {{ lang.SPM022 }}
          </button>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "ShopperProposalModal",
  components: {
    Select2,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      shoppers: [],
      statusData: {},
      selectedShopper: "",
      selectedCarSegment: "",
      selectedCarModel: "",
      selectedCompetitorCar: "",
      selectedCarMatch: "=",
      selectedShopperCar: "",
      shopperPreviousVisits: [],
      shopperPreviousVisited: false,
      carSegmentList: [],
      carModelList: [],
      shopperCars: [],
      lang: {
        SPM000: "Shopper Proposal",
        SPM001: "Car segment / model",
        SPM002: "Please select a segment...",
        SPM003: "Please select an audi car model...",
        SPM004: "Competitor car model",
        SPM005: "...or a competitor car...",
        SPM006: "Shopper",
        SPM007: "Please select a shopper...",
        SPM008: "Shopper car / Match",
        SPM009: "Please select a shopper car...",
        SPM010: "Upgrade",
        SPM011: "Match",
        SPM012: "Downgrade",
        SPM013: "Name",
        SPM014: "Model",
        SPM015: "Segment",
        SPM016: "Car",
        SPM017: "Match",
        SPM018: "Actions",
        SPM019: "Open conversation",
        SPM020: "Update shopper profile data",
        SPM021: "Delete proposal",
        SPM022: "Close",
        SPM023: "Shopper profile data updated",
        SPM024: "Shopper profile data update failed",
        SPM025: "Shopper proposal added",
        SPM026: "Shopper proposal failed",
        SPM027: "Shopper proposal deleted",
        SPM028: "Shopper proposal deletion failed",
        SPM029: "Delete Shopper Proposal",
        SPM030: "Yes",
        SPM031: "No",
        SPM032: "Do you really want to delete the following shopper proposal?",
        SPM033: "Shopper car access failed",
        SPM034: "Shopper already checked the same location in the past!",
        SPM035: "Error while getting shopper who previous visited",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars"
      },
    };
  },
  computed: {
    unproposedShoppers() {
      if (!this.check.ShopperProposals) return this.shoppers;
      return _.filter(this.shoppers, (shopper) => {
        return (
          _.findIndex(
            this.check.ShopperProposals,
            (proposal) => proposal.ShopperGuid === shopper.ShopperGuid
          ) < 0
        );
      });
    },
    anyShopperAlreadyApproved() {
      if (!this.check.ShopperProposals) return false;
      return (
        _.findIndex(
          this.check.ShopperProposals,
          (proposal) => proposal.MainEntityApprovalStatus === "Approved"
        ) > -1
      );
    },
    carModelsOfSelectedSegment() {
      return _.filter(this.filteredCarModelList, (model) => {
        return (
          _.findIndex(model.CarSegments, (segment) => segment.CarSegmentGuid === this.selectedCarSegment) > -1 &&
           _.findIndex(this.check.CarModelDistribution, (audiCars) => audiCars.CarModelGuid === model.CarModelGuid) > -1
        );
      });
    },
    
    // #2135
    filteredCarModelList() {
      // filter importer specific car models
      var importerSpecificCarModelList = this.carModelList.filter(carModel => carModel.ImporterGuid === this.check.ImporterGuid);
      var filteredList = this.carModelList.filter((carModel) => {
        var keepIt = true;
        importerSpecificCarModelList.forEach(element => {
          if(carModel.CarModelName === element.CarModelName) keepIt = false;
        });
        if(keepIt) return carModel;
      })

      // merge
      filteredList = [...filteredList, ...importerSpecificCarModelList];

      // sort filteredList by CarModelName, ImporterName
      filteredList = filteredList.sort((a, b) => {
        const nameA = a.CarModelName.toUpperCase();
        const nameB = b.CarModelName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        const nameC = a.ImporterName ? a.ImporterName.toUpperCase() : "";
        const nameD = b.ImporterName ? b.ImporterName.toUpperCase() : "";
        if (nameC < nameD) {
          return -1;
        }
        if (nameC > nameD) {
          return 1;
        }

        // name and importer name must be equal
        return 0;
      });

      // remove duplicates
      // keep first of duplicates which has no importer
      var uniqueList = [];
      var isIncluded = false
      filteredList.forEach((element) => {
        isIncluded = false;
        uniqueList.forEach((uniqueElement) => {
          if(uniqueElement.CarModelName === element.CarModelName) isIncluded = true;
        })
        if(!isIncluded) uniqueList.push(element);
      })

      return uniqueList;
    }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    },
  },
  created() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getShopperList((data) => {
      this.shoppers = [];
      for (let guid in data) {
        this.shoppers.push({
          ShopperGuid: guid,
          ShopperName: data[guid],
        });
      }
    });

    this.globals.getCarSegmentList((data) => {
      this.carSegmentList = data;
    });
    this.globals.getCarModelList((data) => {
      this.carModelList = data;
    });
  },
  mounted() {
    this.getWaveStatus();
    this.openModal();

    $("#shopperProposalModal").on("hidden.bs.modal", (e) =>
      this.$emit("modalClosed")
    );
  },
  methods: {
    openModal() {
      this.selectedShopper = "";
      this.selectedShopperCar = "";
      this.selectedCarMatch = "=";
      this.shopperPreviousVisited = false;
      $("#shopperProposalModal").modal("show");
    },
    closeModal() {
      $("#shopperProposalModal").modal("hide");
    },
    showFeed(proposal) {
      this.globals.$emit("openFeedModal", {
        ItemGuid: proposal.ShopperProposalGuid,
        FeedType: "ShopperProposal",
        FeedName: "LeadAgencyLocalAgency",
      });
    },    
    async shopperAlreadyChecked() {
      let shopperPreviousVisits = await this.getPreviousVisits();
      if (this.selectedShopper && shopperPreviousVisits.length > 0) {
        for (let i = 0; i < shopperPreviousVisits.length; i++) {
          if (shopperPreviousVisits[i].ShopperGuid == this.selectedShopper) {
            this.shopperPreviousVisited = true;
            return true;
          }
        }
        this.shopperPreviousVisited = false;
        return false;
      } else {
        this.shopperPreviousVisited = false;
        return false;
      }
    },
    getPreviousVisits() {
      let query = `/api/Shopper/PreviousVisits/${this.check.SurveyInstanceId}`;

      return new Promise((resolve, reject) => {
        $.ajax({
          methode: "GET",
          url: query,
          dataType: "json",
          success: (data) => {
            this.shopperPreviousVisits = data;
            resolve(data);
          },
          error: (error) => {
            console.error("Error on GET in getPreviousVisits()");
            this.globals.showErrorSnackbar(this.lang.SPM035);
            reject(error);
          },
        });
      });
    },
    updateShopperData(proposal) {
      let query = `/api/Approval/ShopperProposal/${proposal.ShopperProposalGuid}`;

      $.ajax({
        method: "PATCH",
        url: query,
        dataType: "json",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.SPM023);
          this.$emit("dataUpdated");
        },
        error: (error) => {
          console.error("Error on PATCH in updateShopperData()");
          this.globals.showErrorSnackbar(this.lang.SPM024);
        },
      });
    },
    addShopper() {
      let sendData = {
        SurveyInstanceGuid: this.check.SurveyInstanceGuid,
        ShopperGuid: this.selectedShopper,
        CarSegmentGuid: this.selectedCarSegment,
        CarModelGuid: this.selectedCarModel,
        CarMatch: this.selectedCarMatch,
      };

      if (this.selectedCompetitorCar) {
        sendData.CompetitorCarModelGuid = this.selectedCompetitorCar;
        delete sendData.CarModelGuid;
      }

      let shopperCar = _.find(
        this.shopperCars,
        (car) => car.ValueGroupGuid === this.selectedShopperCar
      );
      if (shopperCar)
        sendData.SelectedShopperGroupProperties = [
          {
            ValueGroupGuid: shopperCar.ValueGroupGuid,
            ShopperPropertyGroupGuid: shopperCar.ShopperPropertyGroupGuid,
          },
        ];

      let query = `api/Approval/ShopperProposal`;
      $.ajax({
        method: "POST",
        url: query,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.SPM025);
          this.selectedShopper = "";
          this.selectedShopperCar = "";
          this.$emit("dataUpdated");
        },
        error: (error) => {
          console.error("Error on POST in addShopper()");
          this.globals.showErrorSnackbar(this.lang.SPM026);
        },
      });
    },
    deleteShopper(shopper) {
      this.globals.$off("DeleteShopperProposalYesConfirmation");
      this.globals.$on("DeleteShopperProposalYesConfirmation", () => {
        $.ajax({
          method: "DELETE",
          url: `api/Approval/ShopperProposal/${shopper.ShopperProposalGuid}`,
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            this.globals.showSuccessSnackbar(this.lang.SPM027);
            this.$emit("dataUpdated");
          },
          error: () => {
            console.error("Error on DELETE in deleteShopper()");
            this.globals.showErrorSnackbar(this.lang.SPM028);
          },
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteShopperProposal",
        confirmationTitle: this.lang.SPM029,
        colorRed: true,
        yesButtonText: this.lang.SPM030,
        noButtonText: this.lang.SPM031,
        htmlText: `<p>${this.lang.SPM032}</p>
                  <p><b>${shopper.DisplayName}</b></p>`,
      });
    },
    getShopperCars() {
      this.shopperCars = [];
      if (!this.selectedShopper) return;
      $.ajax({
        method: "GET",
        url: `api/ShopperProperty/AUDI/CarsOfShopper/${this.selectedShopper}`,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.shopperCars = data;
        },
        error: () => {
          console.error("Shopper car access failed in getShopperCars()");
          this.globals.showErrorSnackbar(this.lang.SPM033);
        },
      });
    },
    getWaveStatus() {
      if (!this.check.WaveGuid) return;
      let query = `api/ProjectWaves/${this.check.WaveGuid}/AgencyStatus?ApprovalStatus=all`;   

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) this.statusData = data;          
        },
        error: (error) => {
          console.error("Error on GET in getWaveStatus()");
          this.globals.showErrorSnackbar(this.lang.AWS035);
        },
      });
    },
    getGroupedCompetitorCars() {
      if (!this.statusData.CompetitorCarDistribution) {
        return [];
      }

      let carBrandMap = new Map();
      for (let ccd of this.statusData.CompetitorCarDistribution) {
        if (ccd.CompetitorCarBrand !== this.check.Brand) continue;
        if (!carBrandMap.has(ccd.CompetitorCarBrand)) {
          carBrandMap.set(ccd.CompetitorCarBrand, []);
        }
        carBrandMap.get(ccd.CompetitorCarBrand).push(ccd);
      }
      return Array.from(carBrandMap);
    }
  },
};
</script>

<style scoped>
.modal-lg {
  width: 1000px;
}

.btn-fab {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  border: 2px solid #ddd;
  background: white !important;
  font-size: 36px;
}
.btn-fab .material-icons {
  position: absolute !important;
  left: 12px !important;
  top: 18px !important;
}

.table td > .btn:disabled > .material-icons {
  color: lightgray !important;
}

.form-group-inline {
  display: inline;
}

hr {
  border-top: 2px solid #eee;
}
.table-container {
  max-height: calc(100vh - 220px);
  overflow: auto;
  margin: 10px 0;
  padding: 0 20px;
}

</style>



// WEBPACK FOOTER //
// ShopperProposalModal.vue?3b362413